import { IconName } from '@ardoq/icons';
import { CanvasRenderingContext } from 'tabview/canvasRendering/types';
import { svgImage } from 'tabview/canvasRendering/canvasResolvedImages';

const drawSpriteIcon = (
  iconName: IconName,
  size: number,
  color: string,
  x: number,
  y: number,
  context: CanvasRenderingContext
) => {
  const img = svgImage(`${iconName}~~${color}~~~~~~${size}~~${size}~~`);
  context.drawImage(img, x - size / 2, y - size / 2, size, size);
};

export { drawSpriteIcon };
